import React, { Component, } from 'react'

import PropTypes from 'prop-types';

import { strings,CCIcon,CCDp  } from './../../cc-imports'

// import './cc-more-modal-item.css'

import './../../styles/css/components/CCMoreModalItem/cc-more-modal-item.css'

class SideBarItem extends Component {

    static propTypes = {
        type: PropTypes.string,
        name: PropTypes.string,
        title: PropTypes.string,
        onPress: PropTypes.func,

        onDpPress: PropTypes.func,
        dpEditable : PropTypes.bool,
        dpLoading : PropTypes.bool

    }


    static defaultProps = {
        type: 'content',
        name: '',
        text: '',

        onPress: ()=>{},
        onDpPress : ()=>{},
        dpEditable : false,
        dpLoading:false
    }

    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const {user, dpLoading, dpEditable} = this.props;

        if (this.props.type === 'user') {
            return (
                <div className="flex-container btn" onClick={this.props.onPress}>
                    {
                            <div className="flex-container cc-more-modal-user">
                                <div className={"flex-container cc-more-modal-user-dp"}>
                                    <CCDp imgClass={'profile-dp'} loading={dpLoading} editable={dpEditable} onClick={this.props.onDpPress} user={user}/>
                                    {/*<CCDp className={'cc-more-modal-ccdp '} imageClassName={'cc-more-modal-ccdp-img'} loading={dpLoading} editable={dpEditable} onClick={this.props.onDpPress} user={user}></CCDp>*/}
                                </div>
                                {
                                    user.id ?
                                        <div className="flex-container cc-more-modal-user-profile" >
                                            <h1 className={'cc-more-modal-user-name'}>{user.displayName}</h1>
                                            <h4 className={'cc-more-modal-user-email'}>{user.email}</h4>
                                        </div>
                                        :
                                        <div className={"flex-container cc-more-modal-user-profile"}>
                                            <h1 className={'cc-more-modal-user-login-title'}>{strings('login_register')}</h1>
                                        </div>
                                }
                            </div>
                    }
                </div>
            )
        }
        else if (this.props.type == 'content') {
            return (
                <div className="flex-container shadow btn cc-more-modal-content"  onClick={this.props.onPress}>
                    <div className={'flex-container cc-more-modal-content-sub'}>
                        <div className="flex-container cc-more-modal-content-sub2">
                            <CCIcon className={'cc-icon-s cc-more-modal-icon'} type={this.props.name.toLowerCase()} ></CCIcon>
                            <h2 className={'flex-container cc-more-modal-content-title'}>{this.props.title}</h2>
                        </div>
                    </div>
                </div>
            )
        }
    }
}

export default SideBarItem


// WEBPACK FOOTER //
// ./src/app/components/CCMoreModalItem/CCMoreModalItem.js